import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { observable } from 'mobx';

@observer
class InputTextField extends Component {
  @observable touched = false;

  constructor(props) {
    super(props);

    this.onBlurHandler = this.onBlurHandler.bind(this);
  }

  onBlurHandler() {
    this.touched = true;
  }

  get inputComponent() {
    const { name, type, onChange, onPaste, placeholder, value, autoComplete, readOnly, maxLength } = this.props.input;

    return (
      <input
        className="input-text"
        name={name}
        value={value || ''}
        type={type}
        onChange={onChange}
        onBlur={this.onBlurHandler}
        placeholder={placeholder}
        autoComplete={autoComplete || 'new-password'}
        onPaste={onPaste}
        disabled={!!readOnly}
        maxLength={maxLength || ''}
      />
    );
  }

  render() {
    const { name } = this.props.input;
    const { errors } = this.props.meta;

    return (
      <div className="input-text-field">
        <div className="input-text-wrapper">{this.inputComponent}</div>
        <div className={`field-group-error ${this.touched && errors[name] ? '' : 'hidden'}`}>{errors[name]}</div>
      </div>
    );
  }
}

export default InputTextField;



// WEBPACK FOOTER //
// ./src/common/components/fields/InputTextField.jsx